<template>
	<div class="login-page__content">
		<div class="nav-background md:nav-background--right">
			<div class="nav-background__img">
				<img :src="getAssetPath('backgrounds/login-page-bg.jpg')"/>
			</div>
		</div>

		<div class="gr pt-12">
			<div class="text-white text-center mt-2 sm:mt-10 sm:pt-1 mb-3 sm:mb-6">
				<h2 class="text-3xl sm:text-4xl sm:mb-2">Set your new password</h2>
				<h3 class="text-lg sm:text-2xl">Please enter your new password below.</h3>
			</div>

			<div class="login-box sm:bg-ma-gray-0">
				<SetNewPasswordForm />
			</div>
		</div>
	</div>
</template>

<script>
	import SetNewPasswordForm from './components/SetNewPasswordForm';
  import { getAssetPath } from '@/utils/contentDelivery';

	export default {
		components: {
			SetNewPasswordForm
		},
		metaInfo: () => ({
            bodyAttrs: { class: 'with--nav-background login-page'},
            title: 'Set your new password | Motion Array',
            link: [ {  rel:'stylesheet', href: '/assets/site/css/login.css?v=2' } ]
        }),
    methods: {
      getAssetPath,
    }
	}
</script>